import { render } from "./BlogItem2.vue?vue&type=template&id=248c1ec9&scoped=true"
import script from "./BlogItem2.vue?vue&type=script&lang=js"
export * from "./BlogItem2.vue?vue&type=script&lang=js"

import "./BlogItem2.vue?vue&type=style&index=0&id=248c1ec9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248c1ec9"]])

export default __exports__